import { createFileRoute } from "@tanstack/react-router";
import { ProceduresScreen } from "../screens/ProceduresScreen";

export const Route = createFileRoute("/_app/procedures/")({
  component: ProceduresScreen,
});
